export const order = {
  ALL: 'Alle',

  // Experience
  JOB: 'Arbeitsplätze',

  // Publications
  COURSE: 'Kurse',
  EXAM: 'Prüfungen',
  DEGREE: 'Abschlüsse',

  // Projects
  WEB: 'Websites',
  MOBILE: 'Mobile Apps',
  PERSONAL_PROJECTS: 'Persönliche Projekte',

  // Certificates
  THESIS: 'Thesis',
  JOURNAL: 'Zeitschrift',
  CONFERENCE: 'Konferenz',

  // Skills
  CURRENT: 'Verwende derzeit',
  PAST_FREQUENTLY: 'Habe in der Vergangenheit häufig verwendet',
  PAST_OCCASIONALLY: 'Kenne mich ein wenig aus',
};
